import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
    DisabilityCoverageAmountHighestValue,
    DisabilityCoverageAmountSurplusValue,
} from '../definitions/CurrentDocument';


function formatDisabilityCoverageAmount(disabilityValue) {
    return (
        // If the value is the final item in the array (over-15000),
        // then render the previous value with a "+" at the end
        <FormattedMessage
            id="InsLifeWizard.CoverageDisabilityQuestions.disabilityCoverageOption"
            defaultMessage="{value, number, CAD0}{isLastItem, select, true {+} other {}}"
            values={{
                value: disabilityValue === DisabilityCoverageAmountSurplusValue
                    ? DisabilityCoverageAmountHighestValue
                    : disabilityValue
                ,
                isLastItem: disabilityValue === DisabilityCoverageAmountSurplusValue,
            }}
        />
    );
}

export default formatDisabilityCoverageAmount;
